export enum DeleteReason {
  blankPage = 0,
  other = 1,
}

export class DeleteReasonNames {
  static readonly [DeleteReason.blankPage] = 'Blank Page';
  static readonly [DeleteReason.other] = 'Other';
}
